import React from 'react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { InputAdornment, TextField } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useBookingCopyTranslation as useTranslation } from '../../i18n/bookingCopy';

export interface TutorBookingStudentSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TutorBookingStudentSearchField: React.FC<TutorBookingStudentSearchFieldProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={t('tutorBookingRequests.searchByStudentPlaceholder', 'Search by student name')}
      disabled={disabled}
      inputProps={{
        'aria-label': t('tutorBookingRequests.searchByStudentPlaceholder', 'Search by student name'),
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchRoundedIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        maxWidth: { xs: '100%', sm: 280 },
        width: { xs: '100%', sm: 260 },
        '& .MuiOutlinedInput-root': {
          bgcolor: (theme) =>
            alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.04 : 0.7),
          borderRadius: 1.5,
        },
      }}
    />
  );
};

export default TutorBookingStudentSearchField;
